import React from 'react';

export default function WoodenPressIcon() {
    return (
        <span className="ps-menu-wooden-press" aria-hidden="true">
            <svg viewBox="0 0 48 40" fill="none" focusable="false">
                <path d="M8 19h30l-3 15c-7 4-17 4-24 0L8 19Z" fill="#9b633b" stroke="#633e28" strokeWidth="1.3" />
                <path d="m15 22 1 11m7-10v12m8-13-1 11" stroke="#d7ad73" strokeWidth="1.2" strokeLinecap="round" />
                <ellipse cx="23" cy="19" rx="15" ry="5" fill="#be8b52" stroke="#633e28" strokeWidth="1.3" />
                <ellipse cx="23" cy="19" rx="9" ry="2.5" fill="#61422b" />
                <g className="ps-menu-wooden-press__spindle">
                    <path d="M22 5h4l-1 15h-3L22 5Z" fill="#a36d3f" stroke="#633e28" strokeWidth="1.2" />
                    <path d="m7 7 32-3" stroke="#633e28" strokeWidth="3" strokeLinecap="round" />
                    <path d="m8 6 30-3" stroke="#c49360" strokeWidth="1" strokeLinecap="round" />
                </g>
                <path d="m36 25 6 1v3h-7" fill="#a36d3f" stroke="#633e28" strokeWidth="1.2" strokeLinejoin="round" />
                <path className="ps-menu-wooden-press__oil" d="M41 30c0 0-3 3-3 5a3 3 0 0 0 6 0c0-2-3-5-3-5Z" fill="#c59737" />
                <path d="M9 37h27" stroke="#633e28" strokeWidth="1.4" strokeLinecap="round" />
            </svg>
        </span>
    );
}
